import { render } from "./ContactPage.vue?vue&type=template&id=4ff928a1&scoped=true&ts=true"
import script from "./ContactPage.vue?vue&type=script&lang=ts"
export * from "./ContactPage.vue?vue&type=script&lang=ts"

import "./ContactPage.vue?vue&type=style&index=0&id=4ff928a1&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\mytransfers-extranet-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff928a1"]])

export default __exports__